module.exports = __webpack_public_path__ + "img/poolfunds.be816710.svg";